import { Pipe, PipeTransform } from '@angular/core';
import { ESTATE_FORMULE }     from '@shared/enums/ESTATE_FORMULE';

@Pipe ({ standalone: true, name: 'CheckEligiblePipe', pure: false })
export class CheckEligiblePipe implements PipeTransform {
  transform (state: ESTATE_FORMULE): boolean {
    return [ESTATE_FORMULE.CHECKED, ESTATE_FORMULE.SHOW].includes (state);
  }
}
